module.exports = __webpack_public_path__ + "img/_ico.efc75dae.svg";